/**
 * Идентификатор установки.
 *
 * Хранится в localStorage, а не в IndexedDB: он нужен до открытия базы, чтобы
 * знать, чьё пространство загружать. Это не идентификатор личности, а ключ
 * локального пространства (ТЗ FR-WS-06).
 */

import type { InstallationId } from '@type2x/shared-contracts';
import type { IdFactory } from '@type2x/feature-personal-workspace';

const STORAGE_KEY = 'type2x.installation-id';

/**
 * Возвращает идентификатор установки, создавая его при первом визите.
 *
 * Если localStorage недоступен, идентификатор создаётся на время сессии:
 * пользователь всё равно может тренироваться, просто прогресс не переживёт
 * перезагрузку.
 */
export function resolveInstallationId(ids: IdFactory): InstallationId {
  try {
    const existing = globalThis.localStorage.getItem(STORAGE_KEY);
    if (existing !== null && existing !== '') return existing as InstallationId;

    const created = ids.newInstallationId();
    globalThis.localStorage.setItem(STORAGE_KEY, created);
    return created;
  } catch {
    return ids.newInstallationId();
  }
}

/** Удаляет идентификатор установки. Используется при полном сбросе. */
export function forgetInstallation(): void {
  try {
    globalThis.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Хранилище недоступно — забывать нечего.
  }
}
